import { render } from "./ExistingRecipientsModal.vue?vue&type=template&id=0b0d7236"
import script from "./ExistingRecipientsModal.vue?vue&type=script&lang=js"
export * from "./ExistingRecipientsModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/LeonardoMBP/Documents/GitHub/swagible-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__